__turbopack_context__.v({
  "label": "uE8frq_label",
  "trigger": "uE8frq_trigger",
});
